"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendSms = sendSms;
var _view = require("../../types/view");
var _registration = require("../../types/registration");
var _sentEmail = require("../../types/sentEmail");
var _action_types = require("../../constants/action_types");
var _sendSms = require("../../api/sendSms");
var _view2 = require("../view");
function sendSms(_ref) {
  let {
    email,
    phone
  } = _ref;
  return (dispatch, _getState, context) => {
    dispatch({
      status: _registration.ESendSmsStatus.Loading,
      type: _action_types.REGISTRATION_SEND_SMS_TYPE
    });
    return (0, _sendSms.sendSms)(context.httpApi, {
      validationType: 'PhoneNumber',
      email,
      phone,
      subdomain: context.subdomain
    }).then(response => {
      if (response.statusCode === 200 && response.response.success) {
        dispatch({
          status: _registration.ESendSmsStatus.Succeed,
          type: _action_types.REGISTRATION_SEND_SMS_TYPE
        });
        dispatch((0, _view2.changeView)(_view.EActiveView.ConfirmPhone, {
          email,
          phone
        }));
        return;
      }
      dispatch({
        status: _registration.ESendSmsStatus.Failed,
        type: _action_types.REGISTRATION_SEND_SMS_TYPE,
        error: 'Не удалось отправить проверочный код'
      });
      dispatch((0, _view2.changeView)(_view.EActiveView.EmailSent, {
        type: _sentEmail.ESentEmailType.Registration,
        email
      }));
    }).catch(error => {
      context.logger.error(error, {
        domain: 'auth-widget.api.sendSms'
      });
      dispatch({
        status: _registration.ESendSmsStatus.Failed,
        type: _action_types.REGISTRATION_SEND_SMS_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}